import logo from '../assets/icons/notification_logo.png';
import Client from '../infra/http/AxiosClient';
import ToastService from '../services/ToastService';

let notification_messages = undefined;
const DEFAULT_TITLE = 'EFRS Notification';
const DISABLE_WEB_NOTIFICATIONS = true;

const loadNotificationMessages = async (executeOnStart) => {
  if(!notification_messages) {
    notification_messages = new Map();
    Client.get('/notifications').then( result => {
      result.data.map(val => {
        const options = {...val};
        delete options.id;
        notification_messages.set(val.id, options);

        return {id: val.id, options};
      });
      try{
        if(executeOnStart){
          executeOnStart(notification_messages);
        }
      } catch (error) {
        console.log('Error on executing callback on load notifications', error);
      }
    }).catch( error => {
      console.log('Error getting notifications.');
    });
  }
}

export const notificationStart = (executeOnStart) => {
  if (!('Notification' in window)) {
    console.log('Notifications are not supported in this browser.')
  }
  else if (Notification.permission !== 'denied') {
    Notification.requestPermission(function (permission) {
      if (permission === 'granted') {
        console.log('Granted permissions to notifications.')
      }
    });
  }
  // Will be used for Toasts even if notifications are not allowed
  loadNotificationMessages(executeOnStart);
}

export const showNotification = (title, options, onClickURL) => {
  if (('Notification' in window) && (Notification.permission==='granted') && (!DISABLE_WEB_NOTIFICATIONS)){
    const icon = logo;
    let finalTitle, finalOptions;

    finalTitle = title ? title: DEFAULT_TITLE;
    finalOptions = options ? options : {};

    if (!finalOptions.icon)
      finalOptions.icon = icon;

    const notification = new Notification(finalTitle, finalOptions);

    if(onClickURL)
      notification.addEventListener('click', () => {
        window.open(onClickURL);
      });
  }
}

const showToast = message => {
  ToastService.info(message);
}

const showNotificationType = (type, options) => {
  if(notification_messages.size === 0){
    if(type!=='welcome')
      showToast(`You received a new ${type}.`);
    return;
  }
  const notification_options = notification_messages.get(type);
  let new_options = null;

  if(type!=='welcome')
    showToast(notification_messages.get(type).title);

  switch(type){
    case 'welcome':
      // Not showing anymore welcome notifications. Will it be definitive?
      // showNotification(notification_messages.get(type).title);
      break;
    case 'message':
      new_options = {
        body: notification_options.body.replace(':username', options.from),
        onClickURL: '/messages'
      }
      showNotification(notification_options.title, new_options);
      break;
    case 'document':
      new_options = {
        body: notification_options.body.replace(':documentname', options.document_name),
        onClickURL: '/documents'
      }
      showNotification(notification_options.title, new_options);
      break;
    case 'post':
      new_options = {
        body: notification_options.body.replace(':username', options.from).replace(':postname', options.postname),
        onClickURL: '/wall'
      }
      showNotification(notification_options.title, new_options);
      break;
    case 'mention':
      new_options = {
        body: notification_options.body.replace(':username', options.from).replace(':postname', options.postname),
        onClickURL: '/wall'
      }
      showNotification(notification_options.title, new_options);
      break;
    case 'group invitation':
      new_options = {
        body: notification_options.body.replace(':groupname', options.groupname),
        onClickURL: '/groups'
      }
      showNotification(notification_options.title, new_options);
      break;
    default:
      const default_options = notification_messages.get('default');
      showNotification(default_options.title, {body: default_options.body});
      break;
  }
}

export const showNotificationWS = payload => {
  showNotificationType(payload.type, payload.options);
}



// WEBPACK FOOTER //
// ./src/services/NotificationService.js